import { motion } from 'framer-motion'

const capabilities = [
  {
    title: 'Prosthetic Components',
    text: 'Knee joints, carbon fiber feet, adapters, liners and suspension systems for lower limb prostheses.'
  },
  {
    title: 'Upper Limb Solutions',
    text: 'Cosmetic silicone hands and myoelectric hand options for daily function and natural appearance.'
  },
  {
    title: 'Workshop Materials',
    text: 'Carbon fiber cloth, socks and supporting materials for prosthetic workshops and fitting centers.'
  },
  {
    title: 'Export Service',
    text: 'International trade support, product matching and logistics coordination for rehabilitation buyers.'
  }
]

const Services = () => {
  return (
    <section id="services" className="bg-white py-20">
      <div className="container mx-auto px-4">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:items-end">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55 }}
            viewport={{ once: true }}
          >
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-teal-700">
              Business Scope
            </p>
            <h2 className="mt-4 text-4xl font-semibold leading-tight text-slate-950 md:text-5xl">
              A focused catalog for rehabilitation supply chains.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-lg leading-8 text-slate-600"
          >
            Products cover rehabilitation, prosthetics, orthotics and related fields to meet
            diverse global customer needs. The company keeps the customer first and quality first
            philosophy at the center of every product and service decision.
          </motion.p>
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-lg border border-slate-200 bg-slate-200 md:grid-cols-2 lg:grid-cols-4">
          {capabilities.map((item, index) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-[#fbfcfa] p-7"
            >
              <span className="text-sm font-semibold text-teal-700">0{index + 1}</span>
              <h3 className="mt-5 text-xl font-semibold text-slate-950">{item.title}</h3>
              <p className="mt-4 text-sm leading-7 text-slate-600">{item.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
